// extracted by mini-css-extract-plugin
export default {"CompactCommentInputContainer":"CompactCommentButton-module__CompactCommentInputContainer--WNtZq"};